import { render, staticRenderFns } from "./57.vue?vue&type=template&id=b28775be&scoped=true&"
var script = {}
import style0 from "./57.vue?vue&type=style&index=0&id=b28775be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28775be",
  null
  
)

export default component.exports